<template>
    <div class="main-content setting">
        <h2>基本信息</h2>
        <div class="b-b m-b-md"></div>
        <div class="clearfix">
            <form>
                <div class="clearfix">
                    <div class="col-xs-12 col-sm-8">
                        <div class="row">
                            <div class="input-item">
                                <label class="col-sm-4 n-p-r text-right">昵称：</label>
                                <div class="col-sm-6">
                                    <input type="text" class="input" placeholder="昵称：轻舞飞扬" required="required" v-model.trim="userinfo.nickname" autocomplete="off">
                                    <span class="input-tips">{{error.nickname}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="input-item">
                                <label class="col-sm-4 n-p-r text-right">姓名：</label>
                                <div class="col-sm-6">
                                    <input type="text" class="input" placeholder="姓名：华宇互联" required="required" v-model.trim="userinfo.realname" autocomplete="off">
                                    <span class="input-tips">{{error.realname}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="input-item">
                                <label class="col-sm-4 n-p-r text-right">邮箱：</label>
                                <div class="col-sm-6">
                                    <div class="row">
                                        <div class="col-xs-9 n-p-r">
                                            <input type="text" class="input" placeholder="邮箱：test@test.com" required="required" :readonly="action_status.email === 0" v-model.trim="userinfo.email" autocomplete="off">
                                        </div>
                                        <div class="col-xs-3 n-p-l-r">
                                            <label class="small color-primary pointer" v-show="action_status.email===0" @click="edit(2)">{{action_text.email}}</label class="small">
                                            <label class="small color-primary pointer" v-show="action_status.email===1" @click="cancel(2)">{{action_text.email}}</label class="small">
                                        </div>
                                    </div>
                                    <span class="input-tips">{{error.email}}</span>
                                    <verify-code :val="userinfo.email" :msg="error.email" :type="2" @success="verifySuccess" v-show="action_status.email !== 0"></verify-code>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="input-item">
                                <label class="col-sm-4 n-p-r text-right">手机：</label>
                                <div class="col-sm-6">
                                    <div class="row">
                                        <div class="col-xs-9 n-p-r">
                                            <input type="text" class="input" placeholder="手机：18888888888" required="required" :readonly="action_status.phone === 0" v-model.trim="userinfo.phone" autocomplete="off">
                                        </div>
                                        <div class="col-xs-3 n-p-l-r">
                                            <label class="small color-primary pointer" v-show="action_status.phone===0" @click="edit(1)">{{action_text.phone}}</label class="small">
                                            <label class="small color-primary pointer" v-show="action_status.phone===1" @click="cancel(1)">{{action_text.phone}}</label class="small">
                                        </div>
                                    </div>
                                    <span class="input-tips">{{error.phone}}</span>
                                    <verify-code :val="userinfo.phone" :msg="error.phone" :type="1" @success="verifySuccess" v-show="action_status.phone !== 0"></verify-code>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="input-item">
                                <label class="col-sm-4 n-p-r text-right">性别：</label>
                                <div class="col-sm-6">
                                    <div class="m-t-b-sm">
                                        <input type="radio" value="1" required="required" v-model.trim="userinfo.sex" name="sex" autocomplete="off">男
                                        <input type="radio" value="2" required="required" v-model.trim="userinfo.sex" name="sex" autocomplete="off">女
                                    </div>
                                    <span class="input-tips">{{error.sex}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="input-item">
                                <label class="col-sm-4 n-p-r text-right">年龄：</label>
                                <div class="col-sm-6">
                                    <input type="text" class="input" placeholder="年龄：18" required="required" v-model.trim="userinfo.age" autocomplete="off">
                                    <span class="input-tips">{{error.age}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="input-item">
                                <label class="col-sm-4 text-right n-p-r">
                                    毕业院校：
                                </label>
                                <div class="col-xs-6">
                                    <input type="text" class="input input-md" v-model.trim="userinfo.edu_school" placeholder="毕业院校:清华大学">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="input-item">
                                <label class="col-sm-4 text-right n-p-r">
                                    最高学历：
                                </label>
                                <div class="col-xs-6">
                                    <select v-model.trim="userinfo.education" class="input-md col-xs-12">
                                        <option value="1">博士</option>
                                        <option value="2">硕士</option>
                                        <option value="3">本科</option>
                                        <option value="4">专科</option>
                                        <option value="5">高中</option>
                                        <option value="6">其他</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="input-item">
                                <label class="col-sm-4 text-right n-p-r">
                                    工作年限：
                                </label>
                                <div class="col-xs-6">
                                    <select v-model.trim="userinfo.work_year" class="input-md col-xs-12">
                                        <option value="0">应届生</option>
                                        <option value="1">1年</option>
                                        <option value="2">2年</option>
                                        <option value="3">3年</option>
                                        <option value="4">4年</option>
                                        <option value="5">5年</option>
                                        <option value="6">6年</option>
                                        <option value="7">7年</option>
                                        <option value="8">8年</option>
                                        <option value="9">9年</option>
                                        <option value="10">10年</option>
                                        <option value="11">10年以上</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="input-item">
                                <label class="col-sm-4 n-p-r text-right">QQ：</label>
                                <div class="col-sm-6">
                                    <input type="text" class="input" placeholder="QQ：10000" required="required" v-model.trim="userinfo.qq" autocomplete="off">
                                    <span class="input-tips">{{error.qq}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="input-item">
                                <label class="col-sm-4 n-p-r text-right">签名：</label>
                                <div class="col-sm-6">
                                    <textarea class="input textarea" resize="none" placeholder="个性签名：人在江湖飘，就是要挨刀！" required="required" v-model.trim="userinfo.signature" autocomplete="off"></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-4 ">
                        <img :src="userinfo.avatar" :alt="userinfo.nickname" class="avatar">
                        <div class="p-t-sm text-center">
                            (推荐尺寸:200 x 200,3M以内)
                        </div>
                        <div class="p-t-sm text-center">
                            <button type="button" class="btn btn-sm btn-primary upload-btn" id="upload-avatar-btn">选择头像</button>
                        </div>
                    </div>
                </div>
                <div class="p-t-b-md text-center">
                    <button type="button" class="btn btn-primary" @click="completeInfo()" :disabled="editable">保存用户信息</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import WebUploader from "webuploader";

import { deepCopy } from "../../plugins/utils";
import User from "../../resource/user";

export default {
  data: function() {
    return {
      userinfo: {
        category: 1,
        nickname: "",
        realname: "",
        email: "",
        phone: "",
        signature: "",
        qq: "",
        avatar: "",
        sex: 1,
        age: "",
        education: 3,
        edu_school: "",
        work_year: "0",
        email_is_verify: 1,
        phone_is_verify: 1
      },
      error: {
        nickname: "",
        realname: "",
        email: "",
        phone: "",
        signature: "",
        qq: "",
        avatar: ""
      },
      action_text: {
        email: "修改",
        phone: "修改"
      },
      action_status: {
        email: 0,
        phone: 0
      },
      verify: {
        phone: false,
        email: false
      },
      editable: false
    };
  },
  computed: {
    ...mapGetters({
      user: "loginUser"
    })
  },
  watch: {
    "userinfo.email": function(now) {
      let that = this;
      if (that.global.regex.email.test(now)) {
        that.error.email = "";
        that.verify.email = true;
      } else {
        that.error.email = "请输入正确的邮箱地址";
        that.verify.email = false;
      }
    },
    "userinfo.nickname": function(now) {
      let that = this;
      if (that.global.regex.name.test(now)) {
        that.error.nickname = "";
        that.verify.name = true;
      } else {
        that.error.nickname = "请输入正确的昵称：由字母、数字与汉字组成";
        that.verify.name = false;
      }
    },
    "userinfo.phone": function(now) {
      let that = this;
      if (that.global.regex.phone.test(now)) {
        that.error.phone = "";
        that.verify.phone = true;
      } else {
        that.error.phone = "请输入正确的手机号";
        that.verify.phone = false;
      }
    },
    "userinfo.age": function(now) {
      let that = this;
      if (that.global.regex.age.test(now)) {
        that.error.age = "";
      } else {
        that.error.age = "请输入正确的年龄";
      }
    }
  },
  created: function() {
    let that = this;
    document.title = `个人设置-个人中心|${that.global.name}`;
    if (that.user) {
      for (let prop in that.userinfo) {
        that.userinfo[prop] = that.user[prop] || that.userinfo[prop];
      }
    }
  },
  mounted: function() {
    let that = this;
    let uploader = WebUploader.create({
      auto: true,
      server: "/api/upload",
      pick: {
        id: "#upload-avatar-btn",
        innerHTML: "",
        multiple: false
      },
      // accept: {
      //     title: 'Images',
      //     extensions: 'gif,jpg,jpeg,bmp,png',
      //     mimeTypes: 'image/*'
      // },
      formData: {}
    });
    uploader.on("beforeFileQueued", file => {
      if (!file.type.startsWith("image/")) {
        alert("请选择图片文件后再进行上传");
        return false;
      } else if (file.size > 3145728) {
        alert("请选择3M以内图片进行上传");
        return false;
      } else {
        return true;
      }
    });
    uploader.on("uploadSuccess", (file, res) => {
      if (res.code === 0) {
        that.userinfo.avatar = res.result.url;
      } else {
        alert(res.msg);
      }
    });
  },
  methods: {
    verifySuccess: function(type) {
      const that = this;
      if (type === 1) {
        that.userinfo.phone_is_verify === 1;
      } else {
        that.userinfo.email_is_verify === 1;
      }
      that.edit(type);
    },
    cancel: function(type) {
      const that = this;
      if (type === 1) {
        that.userinfo.phone = that.user.phone;
      } else {
        that.userinfo.email = that.user.email;
      }
      that.edit(type);
    },
    edit: function(type) {
      const that = this;
      // 手机号
      if (type === 1) {
        that.action_text.phone =
          that.action_status.phone === 0
            ? "取消"
            : that.userinfo.phone_is_verify === 1 ? "修改" : "验证";
        that.action_status.phone = that.action_status.phone === 0 ? 1 : 0;
      } else {
        that.action_text.email =
          that.action_status.email === 0
            ? "取消"
            : that.userinfo.email_is_verify === 1 ? "修改" : "验证";
        that.action_status.email = that.action_status.email === 0 ? 1 : 0;
      }
    },
    completeInfo: function() {
      let that = this;
      if (that.editable) {
        return;
      }
      let uinfo = deepCopy(that.userinfo);
      if (that.global.regex.name.test(uinfo.nickname)) {
        that.error.nickname = "";
      } else {
        that.error.nickname = "请输入正确的昵称：由字母、数字与汉字组成";
        return;
      }
      if (!that.global.regex.age.test(uinfo.age)) {
        delete uinfo.age;
        that.userinfo.age = that.user.age;
      }
      delete uinfo.email_is_verify;
      delete uinfo.phone_is_verify;
      that.editable = true;
      User.complete({}, uinfo).then(
        res => {
          let data = res.body;
          if (data.code == 0) {
            that.$store.dispatch("getSession");
            alert("修改已保存");
          } else {
            alert(data.msg);
          }
          that.editable = false;
        },
        res => {
          that.editable = false;
        }
      );
    }
  }
};
</script>
<style lang="less">
select option {
  height: 26px;
  line-height: 26px;
  padding: 10px;
  margin: 0;
  color: #6d6d6d;
  -webkit-appearance: none;
  /*去除系统默认的样式*/
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  /* 点击去除高亮的颜色*/
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// setting.vue?25fa830a